import moment from 'moment';
import 'moment/locale/th'
import numeral from 'numeral';
import { Locale } from '../../language';
moment.locale('th');

export function clearLocalStorage(key) {
  localStorage.removeItem(key);
}

export function registerLocalStorage(key, value) {
  localStorage.setItem(key, value);
}

export function getLocalStorage(key) {
  try {
    const value = localStorage.getItem(key);
    return value
  } catch (err) {
    clearLocalStorage(key);
    return undefined
  }
}

export function isBoolean(variable) {
  switch (typeof variable) {
    case 'string':
      return variable === 'true'
    case 'number':
      return variable !== 0
    default:
      return false
  }
}

export function arrayEqual(array1, array2) {
  return array1.sort().toString() === array2.sort().toString();
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}
class UtilHelperClass {
  formatDateTime01 = 'DD/MM/YYYY HH:mm';

  formatToBuddhistYear = (moment, format) => {
    // https://gist.github.com/akexorcist/eb5e8266670721c191a62851e3d8bb3d
    const christianYear = moment.format('YYYY')
    const buddhishYear = (parseInt(christianYear) + 543).toString()
    return moment
      .format(format.replace('YYYY', buddhishYear).replace('YY', buddhishYear.substring(2, 4)))
      .replace(christianYear, buddhishYear)
  }

  formatThaiDate = (date) => {
    try {
      return `${moment(date).format('Do MMM')} ${moment(date).year() + 543}`;
    } catch (e) {
      return date;
    }
  }

  formatFullDate = (date, locale) => {
    if(locale === Locale.TH){
      return this.formatThaiDate(date);
    } else if (locale) {
      moment.locale(locale.toLowerCase());
    }

    return moment(date).format('DD MMM YYYY');
  }

  toFixedNumberWithoutRound = (number, digit) => {
    if (isNaN(number)) {
      return null
    }

    const regex = new RegExp(String.raw`^-?\d+(?:\.\d{0,${digit}})?`, 'gi');
    const matchedTexts = number.toString().match(regex);
    const firstMatchedText = matchedTexts.length > 0 ? matchedTexts[0] : null;
    if (firstMatchedText) {
      const fixedNumber = Number(firstMatchedText);
      return fixedNumber
    }
    return null
  }

  currencyFormat = (value, isDecimal) => {
    const strValue = String(value);
    if (isNaN(value) || value < 0) {
      // NaN case
      return numeral(0).format(isDecimal ? '0.00' : '0')
    } else if (strValue && strValue.indexOf('.') >= 0) {
      // . case
      const integerPart = strValue.split('.')[0];
      const decimalPart = strValue.split('.')[1];
      const maxNineDigitInteger = integerPart.substring(0, 9);
      const maxTwoDigitDecimal = decimalPart.substring(0, 2);
      const newValue = maxNineDigitInteger + '.' + maxTwoDigitDecimal;
      return numeral(newValue).format(isDecimal ? '0,0.00' : '0,0', Math.floor)
    } else {
      // no . case
      const integerPart = strValue.substring(0, 9);
      return numeral(integerPart).format(isDecimal ? '0,0.00' : '0,0')
    }
  }

  removeComma = (value) => {
    if (value && value.indexOf(',') >= 0) {
      return value.replace(/,/g, '');
    } else {
      return value;
    }
  }
}

export const UtilHelper = new UtilHelperClass();
